<template>
  <div class="geofences-map">
    <google-map
      @ready="googleMapReady"
      @geometry-clicked="polygonClicked"
      @polygon-overlay-created="createPolygon"
      ref="googleMap"
    ></google-map>
  </div>
</template>

<script>
import { find } from 'lodash'

import GoogleMap from '@/components/Maps/Google'

export default {
  name: 'geofences-map',
  props: {
    geofences: {
      type: Array,
      default: function () {
        return []
      }
    },
    drawingGeofence: {
      type: Boolean,
      default: false
    },
    vehicles: {
      type: Array,
      default: function () {
        return []
      }
    },
    focus: String
  },
  data: function () {
    return {
      mapIsReady: false
    }
  },
  computed: {
    polygons: function () {
      return this.geofences.map(geofence => {
        let polygon = {
          path: [],
          id: geofence._id
        }
        for (const coordinate of geofence.geometry.coordinates[0]) {
          polygon.path.push({
            lat: coordinate[1],
            lng: coordinate[0]
          })
        }
        return polygon
      })
    }
  },
  watch: {
    polygons: function () {
      this.updateMapGeofences()
    },
    drawingGeofence: function () {
      this.updateMapDrawingState()
    },
    vehicles: function () {
      this.updateMapVehicles()
    },
    focus: function (focus) {
      const vehicle = find(this.vehicles, { _id: focus })
      if (vehicle && vehicle.position) {
        this.$refs.googleMap.animateMarker(vehicle._id)
        this.$refs.googleMap.panTo(vehicle.position)
      }
    }
  },
  components: {
    'google-map': GoogleMap
  },
  methods: {
    googleMapReady: function () {
      this.mapIsReady = true
      this.updateMapGeofences()
      this.updateMapDrawingState()
    },
    updateMapGeofences: function () {
      if (!this.mapIsReady) return false
      this.$refs.googleMap.removePolygons()
      for (const polygon of this.polygons) {
        this.$refs.googleMap.setGeometryToMap(this.$refs.googleMap.createPolygon({
          polygonOptions: polygon
        }))
      }
    },
    updateMapVehicles: function () {
      if (!this.mapIsReady) {
        return false
      }
      const googleMap = this.$refs.googleMap
      googleMap.removeMarkers()
      for (const vehicle of this.vehicles) {
        if (!vehicle.position) continue
        const marker = googleMap.createMarker({
          markerOptions: {
            position: vehicle.position,
            title: vehicle.plate,
            id: vehicle._id
          }
        })
        googleMap.setGeometryToMap(marker)
      }
      if (this.focus) googleMap.animateMarker(this.focus)
    },
    updateMapDrawingState: function () {
      if (!this.mapIsReady || !this.drawingGeofence) return false
      this.$refs.googleMap.drawPolygon()
    },
    createPolygon: function (overlayPath) {
      const polygon = {
        type: 'Polygon',
        coordinates: [[]]
      }
      for (const path of overlayPath) {
        const coordinate = [
          path.lng(),
          path.lat()
        ]
        polygon.coordinates[0].push(coordinate)
      }
      const firstCoordinate = overlayPath[0]
      polygon.coordinates[0].push([
        firstCoordinate.lng(),
        firstCoordinate.lat()
      ])
      this.$emit('polygon-created', polygon)
    },
    polygonClicked: function ({ type, id }) {
      if (type !== 'Polygon') return false
      this.$emit('polygon-clicked', id)
    }
  }
}
</script>

<style lang="sass" scoped>
.google-map
  height: 100%
  margin: 0
  padding: 0
</style>



// WEBPACK FOOTER //
// src/components/Maps/Geofences.vue